"use client";

import React, { useMemo, useState } from "react";
import logo from "../assets/teckants-logo.png";

import wclient01 from "../assets/websiteclient01.png";
import wclient02 from "../assets/websiteclient02.png";
import wclient03 from "../assets/websiteclient03.png";
import wclient04 from "../assets/websiteclient04.png";
import wclient05 from "../assets/websiteclient05.png";
import wclient06 from "../assets/websiteclient06.jpeg";
import wclient07 from "../assets/websiteclient07.png";

import ourclient1 from "../assets/ourclient1.jpeg";
import ourclient2 from "../assets/client02.webp";
import ourclient3 from "../assets/ourclient3.png";
import ourclient4 from "../assets/ourclient4.jpg";

import reels1 from "../assets/reels1.mp4";
import reels2 from "../assets/reels2.mp4";
import reels3 from "../assets/reels3.mp4";
import reels4 from "../assets/reels4.mp4";
import reels5 from "../assets/reels5.mp4";

const projects = [
  {
    id: "01",
    title: "Dhanvi Wire Products",
    category: "Website Development",
    description:
      "A professional business website for showcasing wire fencing products, solutions and company information with a clean, responsive experience.",
    image: wclient01,
    url: "https://www.dhanviwireproducts.com",
  },
  {
    id: "02",
    title: "One Key Automation",
    category: "Website Development",
    description:
      "A modern website created to present automation solutions, products and services with a clear and engaging digital experience.",
    image: wclient02,
    url: "https://onekeyautomation.com/",
  },
  {
    id: "03",
    title: "TwinStrike Badminton Academy",
    category: "Website Development",
    description:
      "A dedicated website for a badminton academy, designed to showcase the academy, training programs and badminton-focused experience.",
    image: wclient04,
    url: "https://twinstrike.honusvintech.com/",
  },
  {
    id: "04",
    title: "Sri KK Air Conditioners",
    category: "Website Development",
    description:
      "A professional business website built to showcase air conditioning services, solutions and company information with a responsive design.",
    image: wclient03,
    url: "https://www.srikkairconditioners.com",
  },
  {
    id: "05",
    title: "Dhanvi Wire Products",
    category: "Digital Marketing",
    description:
      "Social media marketing focused on showcasing fencing products, strengthening brand visibility and reaching a wider audience through creative content.",
    image: wclient06,
    url: "https://www.instagram.com/dhanviwireproducts/",
  },
  {
    id: "06",
    title: "Lakshmi Dental Clinic",
    category: "Digital Marketing",
    description:
      "Social media marketing focused on building online visibility through engaging dental content, creative campaigns and consistent brand communication.",
    image: wclient05,
    url: "https://www.instagram.com/lakshmidentalclinic_dvk/",
  },
];

const clients = [
  {
    name: "Lakshmi Dental Clinic",
    type: "Dental Clinic",
    reach: "56.8K",
    image: ourclient1,
    instagram: "https://www.instagram.com/lakshmidentalclinic_dvk/",
  },
  {
    name: "Dhanvi wire products",
    type: "Fencing Products",
    reach: "38.4K",
    image: ourclient2,
    instagram: "https://www.instagram.com/dhanviwireproducts/",
  },
  {
    name: "MGR Career Consultancy",
    type: "Career Guidance",
    reach: "106.2K",
    image: ourclient3,
    instagram: "https://www.instagram.com/mgr_academy_dvk/",
  },
  {
    name: "Gaphere",
    type: "Deliery Service",
    reach: "65.7K",
    image: ourclient4,
    instagram: "https://www.instagram.com/gaphere_kkdi/",
  },
];

/* =========================================================
   LIVE WEBSITE DATA
========================================================= */

const liveSites = [
  {
    name: "dhanviwireproducts.com",
    image: wclient01,
    url: "https://www.dhanviwireproducts.com",
  },
  {
    name: "twinstrikes.com",
    image: wclient04,
    url: "https://twinstrike.honusvintech.com/",
  },
  {
    name: "srikkairconditioners.com",
    image: wclient03,
    url: "https://www.srikkairconditioners.com",
  },
  {
    name: "onekeyautomation.com",
    image: wclient02,
    url: "https://onekeyautomation.com/",
  },
];

const reels = [
  {
    id: 1,
    video: reels1,
    link: "https://www.instagram.com/p/DbxVTB3u6M9/",
    category: "Dhanvi wire products",
    title: "Client Testimonial",
  },
  {
    id: 2,
    video: reels2,
    category: "Lakshmi Dental Clinic",
    link: "https://www.instagram.com/p/Dc3Qx1ht_IT/",
    title: "Brushing Tips",
  },
  {
    id: 3,
    video: reels3,
    link: "https://www.instagram.com/p/DcJK9ljTZmF/",
    category: "Devakottai Chairman",
    title: "Opening Ceremony of Namma Devakottai ",
  },
  {
    id: 4,
    video: reels4,
    link: "https://www.instagram.com/p/DZNq-PJT2c5/",
    category: "MGR Career Consultancy",
    title: "Myth of Mechnical Engineering",
  },
  {
    id: 5,
    video: reels5,
    link: "https://www.instagram.com/p/DaUj1ZKC5Qg/",
    category: "A1 Catering",
    title: "Breakfast Menu",
  },
];

/* =========================================================
   ICONS
========================================================= */

function ArrowRight({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

function ArrowUpRight({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 17 17 7" />
      <path d="M7 7h10v10" />
    </svg>
  );
}

function InstagramIcon({ size = 19 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none" />
    </svg>
  );
}

function PlayIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M8 5.5v13L18 12 8 5.5Z" />
    </svg>
  );
}

function MenuIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    >
      <path d="M4 8h16" />
      <path d="M4 16h16" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    >
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </svg>
  );
}

/* =========================================================
   MAIN COMPONENT
========================================================= */

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [mobileMenu, setMobileMenu] = useState(false);

  const filters = ["All", "Websites", "Digital Marketing"];

  const filteredProjects = useMemo(() => {
    if (activeFilter === "All") {
      return projects;
    }

    if (activeFilter === "Websites") {
      return projects.filter((item) => item.category === "Website Development");
    }

    return projects.filter((item) => item.category === "Digital Marketing");
  }, [activeFilter]);

  return (
    <main className="min-h-screen overflow-x-hidden bg-[#f4f8fd] text-[#10203b]">
      {/* =====================================================
          GLOBAL DECORATION
      ===================================================== */}

      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
          background: #f4f8fd;
        }

        ::selection {
          background: #1573ff;
          color: white;
        }

        * {
          scrollbar-width: thin;
          scrollbar-color: #1573ff #e7edf5;
        }

        ::-webkit-scrollbar {
          width: 7px;
        }

        ::-webkit-scrollbar-track {
          background: #e7edf5;
        }

        ::-webkit-scrollbar-thumb {
          background: #1573ff;
          border-radius: 999px;
        }

        @keyframes floatSlow {
          0%,
          100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-12px);
          }
        }

        @keyframes floatSlowReverse {
          0%,
          100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(12px);
          }
        }

        .teckants-float {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .teckants-float-reverse {
          animation: floatSlowReverse 6s ease-in-out infinite;
        }

        @media (prefers-reduced-motion: reduce) {
          html {
            scroll-behavior: auto;
          }

          *,
          *::before,
          *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
        }
      `}</style>

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <header className="absolute left-0 right-0 top-0 z-50">
        <div className="mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-12">
          <div className="flex h-[78px] items-center justify-between">
            {/* Logo */}

            <a href="#home" className="group flex items-center">
              <img
                src={logo}
                alt="TECKANTS"
                className="h-9 w-auto object-contain transition group-hover:opacity-90 sm:h-10"
              />
            </a>

            {/* Desktop Navigation */}

            {/* Desktop CTA */}

            <a
              href="tel:+919442328166"
              className="hidden items-center gap-2 rounded-full border border-[#4d9eff]/30 bg-[#1573ff] px-4 py-2.5 text-xs font-bold text-white shadow-[0_12px_30px_rgba(21,115,255,.22)] transition hover:-translate-y-0.5 hover:bg-[#3188ff] sm:flex"
            >
              Get Started
              <ArrowRight size={14} />
            </a>
          </div>

          {/* Mobile Navigation */}

          {mobileMenu && (
            <div className="rounded-3xl border border-white/10 bg-[#071b3d]/95 p-3 shadow-2xl backdrop-blur-xl lg:hidden">
              {[
                ["Home", "#home"],
                ["About", "#about"],
                ["Services", "#services"],
                ["Work", "#work"],
                ["Clients", "#clients"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <a
                  key={label}
                  href={href}
                  onClick={() => setMobileMenu(false)}
                  className="block rounded-2xl px-4 py-3.5 text-sm font-semibold text-white/75 transition hover:bg-white/10 hover:text-white"
                >
                  {label}
                </a>
              ))}
            </div>
          )}
        </div>
      </header>

      {/* =====================================================
    HERO
===================================================== */}

      <section
        id="home"
        className="relative flex min-h-[720px] items-center justify-center overflow-hidden bg-[#061735] px-5 pt-[78px] text-white sm:px-8 lg:min-h-[820px] lg:px-12"
      >
        {/* Subtle Background Glow */}

        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1573ff]/10 blur-[140px]" />

        <div className="pointer-events-none absolute -left-40 top-20 h-[420px] w-[420px] rounded-full border border-blue-400/[0.05]" />

        <div className="pointer-events-none absolute -right-40 bottom-10 h-[420px] w-[420px] rounded-full border border-blue-400/[0.05]" />

        {/* Content */}

        <div className="relative mx-auto flex max-w-[1050px] flex-col items-center text-center">
          {/* Small Label */}

          <p className="mb-6 text-[10px] font-black uppercase tracking-[0.3em] text-[#4a9bff] sm:text-xs">
            We Create. We Build. We Grow.
          </p>

          {/* Main Heading */}

          <h1 className="text-5xl font-black leading-[0.95] tracking-[-0.07em] sm:text-6xl md:text-7xl lg:text-[92px]">
            Digital Ideas.
            <br />
            <span className="text-[#3d95ff]">Built to Grow.</span>
          </h1>

          {/* Description */}

          <p className="mt-7 max-w-[680px] text-sm leading-7 text-white/50 sm:text-base">
            We create powerful websites and digital marketing experiences that
            turn ideas into brands people remember.
          </p>

          {/* Buttons */}

          <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
            {/* Primary */}

            <a
              href="#work"
              className="group inline-flex min-w-[165px] items-center justify-center gap-2 rounded-full bg-[#1573ff] px-6 py-3.5 text-sm font-black text-white shadow-[0_15px_45px_rgba(21,115,255,.28)] transition duration-300 hover:-translate-y-1 hover:bg-[#3188ff] hover:shadow-[0_20px_55px_rgba(21,115,255,.38)]"
            >
              Explore Our Work
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>

            {/* Secondary */}

            <a
              href="tel:+919442328166"
              className="inline-flex min-w-[165px] items-center justify-center rounded-full border border-white/15 bg-white/[0.04] px-6 py-3.5 text-sm font-black text-white/85 backdrop-blur-md transition duration-300 hover:-translate-y-1 hover:border-white/25 hover:bg-white/10 hover:text-white"
            >
              Start a Project
            </a>
          </div>
        </div>
      </section>

      {/* =====================================================
          ABOUT
      ===================================================== */}

      <section
        id="about"
        className="bg-[#f6f9fd] px-5 py-16 sm:px-8 lg:px-12 lg:py-20"
      >
        <div className="mx-auto max-w-[1500px]">
          <div className="grid gap-8 md:grid-cols-[1fr_1.4fr] md:items-center">
            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.24em] text-[#1573ff]">
                Who We Are
              </p>

              <h2 className="mt-3 text-3xl font-black tracking-[-0.05em] sm:text-4xl lg:text-5xl">
                Creative minds.
                <br />
                <span className="text-[#9badc5]">Digital builders.</span>
              </h2>
            </div>

            <p className="max-w-2xl text-sm leading-7 text-slate-500 sm:text-base">
              TECKANTS is a digital creative studio focused on websites, digital
              marketing and social media. We combine design, technology and
              strategy to help businesses build a stronger online presence.
            </p>
          </div>
        </div>
      </section>

      {/* =====================================================
          SERVICES
      ===================================================== */}

      <section
        id="services"
        className="bg-[#f6f9fd] px-5 pb-20 sm:px-8 lg:px-12 lg:pb-28"
      >
        <div className="mx-auto max-w-[1500px]">
          <div className="grid gap-8 lg:grid-cols-[.75fr_1fr] lg:items-end">
            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#1573ff] sm:text-xs">
                Our Services
              </p>

              <h2 className="mt-3 text-4xl font-black tracking-[-0.05em] sm:text-5xl lg:text-6xl">
                What We Do
              </h2>

              <p className="mt-3 text-sm text-slate-500">
                Best services for your business.
              </p>
            </div>

            <p className="max-w-xl text-sm leading-6 text-slate-500 lg:ml-auto">
              We combine creativity with technology to deliver solutions that
              make an impact. From stunning websites to social media growth, we
              build digital experiences that move businesses forward.
            </p>
          </div>

          <div className="mt-10 grid gap-5 lg:grid-cols-2">
            {/* Digital Marketing */}

            <div className="group relative min-h-[330px] overflow-hidden rounded-[28px] bg-gradient-to-br from-[#0866f5] via-[#126fff] to-[#19baf2] p-7 text-white shadow-[0_22px_55px_rgba(21,115,255,.17)] sm:p-9">
              <div className="absolute right-[-30px] top-10 rotate-12 opacity-[0.11]">
                <InstagramIcon size={170} />
              </div>

              <div className="absolute bottom-[-90px] right-[15%] h-52 w-52 rounded-full border-[40px] border-white/10" />

              <div className="relative">
                <div className="flex items-start justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/15 text-xs font-black">
                    01
                  </div>

                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#1573ff] transition group-hover:rotate-45">
                    <ArrowUpRight size={17} />
                  </div>
                </div>

                <div className="mt-16">
                  <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/60">
                    Growth
                  </p>

                  <h3 className="mt-2 text-3xl font-black tracking-[-0.03em] sm:text-4xl">
                    Digital Marketing
                  </h3>

                  <ul className="mt-5 grid gap-2 text-sm text-white/85 sm:grid-cols-2">
                    <li>✓ Social Media Marketing</li>
                    <li>✓ Content Creation</li>
                    <li>✓ Paid Ads</li>
                    <li>✓ SEO Optimization</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Website Development */}

            <div className="group relative min-h-[330px] overflow-hidden rounded-[28px] bg-[#0a1c3b] p-7 text-white shadow-[0_22px_55px_rgba(8,28,59,.12)] sm:p-9">
              <div className="absolute right-[-40px] top-[-40px] h-56 w-56 rounded-full bg-[#1573ff]/15 blur-3xl" />

              <div className="absolute bottom-[-70px] right-[-20px] h-48 w-48 rounded-full border-[30px] border-blue-400/10" />

              <div className="relative">
                <div className="flex items-start justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#1573ff] text-xs font-black">
                    02
                  </div>

                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#0a1c3b] transition group-hover:rotate-45">
                    <ArrowUpRight size={17} />
                  </div>
                </div>

                <div className="mt-16">
                  <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/40">
                    Digital
                  </p>

                  <h3 className="mt-2 text-3xl font-black tracking-[-0.03em] sm:text-4xl">
                    Website Development
                  </h3>

                  <ul className="mt-5 grid gap-2 text-sm text-white/70 sm:grid-cols-2">
                    <li>✓ Business Websites</li>
                    <li>✓ Landing Pages</li>
                    <li>✓ E-Commerce</li>
                    <li>✓ Maintenance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          OUR WORK
      ===================================================== */}

      <section
        id="work"
        className="bg-white px-5 py-20 sm:px-8 lg:px-12 lg:py-28"
      >
        <div className="mx-auto max-w-[1500px]">
          {/* Heading */}

          <div className="flex flex-col justify-between gap-7 md:flex-row md:items-end">
            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#1573ff] sm:text-xs">
                Our Portfolio
              </p>

              <h2 className="mt-3 text-4xl font-black tracking-[-0.05em] sm:text-5xl lg:text-6xl">
                Our Work
              </h2>

              <p className="mt-2 text-sm text-slate-500">
                A glimpse of what we've created for our clients.
              </p>
            </div>

            {/* Filters */}

            <div className="flex flex-wrap gap-2">
              {filters.map((filter) => (
                <button
                  key={filter}
                  type="button"
                  onClick={() => setActiveFilter(filter)}
                  className={`rounded-full border px-4 py-2.5 text-[11px] font-bold transition ${
                    activeFilter === filter
                      ? "border-[#1573ff] bg-[#1573ff] text-white shadow-lg shadow-blue-500/15"
                      : "border-slate-200 bg-[#f8fafc] text-slate-500 hover:border-[#1573ff]/30 hover:text-[#1573ff]"
                  }`}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>

          {/* Project Grid */}

          <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {filteredProjects.map((project) => (
              <a
                key={project.id}
                href={project.url}
                target="_blank"
                rel="noreferrer"
                className="group overflow-hidden rounded-[23px] border border-slate-200 bg-white shadow-[0_10px_35px_rgba(15,23,42,.04)] transition duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_55px_rgba(15,23,42,.09)]"
              >
                <div className="relative overflow-hidden bg-slate-100">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="aspect-[16/10] w-full object-cover object-top transition duration-700 group-hover:scale-105"
                  />

                  {/* Number */}

                  <div className="absolute left-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/95 text-[10px] font-black shadow-sm">
                    {project.id}
                  </div>

                  {/* Hover Button */}

                  <div className="absolute inset-0 flex items-center justify-center bg-[#0b1b38]/0 transition duration-300 group-hover:bg-[#0b1b38]/15">
                    <div className="translate-y-3 rounded-full bg-white px-4 py-2.5 text-xs font-black text-[#1573ff] opacity-0 shadow-xl transition duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                      View Project
                    </div>
                  </div>
                </div>

                <div className="p-5">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-[9px] font-black uppercase tracking-[0.2em] text-[#1573ff]">
                        {project.category}
                      </p>

                      <h3 className="mt-1 text-lg font-black tracking-tight">
                        {project.title}
                      </h3>
                    </div>

                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-50 text-[#1573ff] transition group-hover:bg-[#1573ff] group-hover:text-white">
                      <ArrowUpRight size={14} />
                    </span>
                  </div>

                  <p className="mt-2 text-xs leading-5 text-slate-500">
                    {project.description}
                  </p>

                  <div className="mt-4 text-xs font-black text-[#1573ff]">
                    View Project →
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
    CLIENTS / SOCIAL REACH
===================================================== */}

      <section
        id="clients"
        className="relative overflow-hidden bg-[#061a40] px-5 py-20 text-white sm:px-8 lg:px-12 lg:py-28"
      >
        {/* Decorative Curves */}

        <div className="absolute right-[-100px] top-[-120px] h-[460px] w-[460px] rounded-full border border-blue-400/10" />

        <div className="absolute right-[-20px] top-[-50px] h-[320px] w-[320px] rounded-full border border-blue-400/10" />

        <div className="absolute bottom-[-220px] left-[20%] h-[450px] w-[450px] rounded-full bg-[#1573ff]/10 blur-[110px]" />

        <div className="relative mx-auto max-w-[1500px]">
          {/* Top */}

          <div className="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end">
            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#3d95ff] sm:text-xs">
                Our Clients
              </p>

              <h2 className="mt-3 text-4xl font-black tracking-[-0.05em] sm:text-5xl">
                Trusted by Growing Brands
              </h2>

              <p className="mt-3 max-w-xl text-sm leading-6 text-white/50">
                We've helped businesses of all sizes build their online presence
                and achieve measurable digital results.
              </p>
            </div>

            {/* Stats */}

            <div className="grid grid-cols-3 gap-6 sm:gap-10">
              <div>
                <p className="text-3xl font-black sm:text-4xl">20+</p>

                <p className="mt-1 text-[8px] font-bold uppercase tracking-wider text-white/35 sm:text-[9px]">
                  Projects Delivered
                </p>
              </div>

              <div>
                <p className="text-3xl font-black sm:text-4xl">10+</p>

                <p className="mt-1 text-[8px] font-bold uppercase tracking-wider text-white/35 sm:text-[9px]">
                  Happy Clients
                </p>
              </div>

              <div>
                <p className="text-3xl font-black sm:text-4xl">90%</p>

                <p className="mt-1 text-[8px] font-bold uppercase tracking-wider text-white/35 sm:text-[9px]">
                  Client Retention
                </p>
              </div>
            </div>
          </div>

          {/* =====================================================
        CLIENT CARDS
    ===================================================== */}

          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {clients.map((client) => (
              <a
                key={client.name}
                href={client.instagram}
                target="_blank"
                rel="noreferrer"
                className="group overflow-hidden rounded-[20px] bg-white p-3 text-[#10203b] transition duration-500 hover:-translate-y-1.5 hover:shadow-[0_25px_60px_rgba(0,0,0,.22)]"
              >
                {/* Header */}

                <div className="flex items-center gap-3 px-2 py-2">
                  <div className="h-9 w-9 overflow-hidden rounded-full bg-slate-100">
                    <img
                      src={client.image}
                      alt={client.name}
                      className="h-full w-full object-cover"
                    />
                  </div>

                  <div className="min-w-0">
                    <p className="truncate text-xs font-black">{client.name}</p>

                    <p className="truncate text-[9px] text-slate-400">
                      {client.type}
                    </p>
                  </div>
                </div>

                {/* Reach */}

                <div className="rounded-xl bg-[#f1f5f9] p-4">
                  <p className="text-2xl font-black">{client.reach}</p>

                  <p className="mt-0.5 text-[9px] font-bold uppercase tracking-wider text-slate-400">
                    Total Reach
                  </p>
                </div>

                {/* Link */}

                <div className="flex items-center justify-between px-2 pb-1 pt-3">
                  <span className="text-[10px] font-black text-[#1573ff]">
                    View on Instagram
                  </span>

                  <span className="transition group-hover:translate-x-1">
                    <ArrowUpRight size={14} />
                  </span>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-20">
            {/* Reels Heading */}

            <div className="mb-8 flex items-end justify-between">
              <div>
                <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#3d95ff] sm:text-xs">
                  Social Proof
                </p>

                <h3 className="mt-2 text-3xl font-black tracking-[-0.04em] sm:text-4xl">
                  Our Work in Motion
                </h3>

                <p className="mt-2 max-w-lg text-sm text-white/45">
                  A glimpse of the brands, campaigns and creative work we've
                  helped bring to life.
                </p>
              </div>
            </div>

            {/* Reels Grid */}

            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
              {reels.map((reel) => (
                <a
                  key={reel.id}
                  href={reel.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative aspect-[9/16] overflow-hidden rounded-[22px] bg-[#0b2857]"
                >
                  <video
                    src={reel.video}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-[1.04]"
                  />

                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/10" />

                  <div className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white/15 backdrop-blur-md">
                    <InstagramIcon size={15} />
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-[10px] font-black uppercase tracking-[0.16em] text-white/60">
                      {reel.category}
                    </p>

                    <p className="mt-1 text-sm font-black text-white">
                      {reel.title}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          LIVE WEBSITES
      ===================================================== */}

      <section className="bg-[#f6f9fd] px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
        <div className="mx-auto max-w-[1500px]">
          <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#1573ff] sm:text-xs">
                Client Websites
              </p>

              <h2 className="mt-3 text-4xl font-black tracking-[-0.05em] sm:text-5xl">
                Live Sites. Real Business.
              </h2>

              <p className="mt-3 max-w-xl text-sm leading-6 text-slate-500">
                Explore some of the websites we've developed for our clients.
                Click to visit and experience them yourself.
              </p>
            </div>

            <a
              href="#work"
              className="group inline-flex items-center gap-2 text-xs font-black text-[#1573ff]"
            >
              View All Projects
              <span className="transition group-hover:translate-x-1">
                <ArrowRight size={15} />
              </span>
            </a>
          </div>

          {/* Website Cards */}

          <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {liveSites.map((site) => (
              <a
                key={site.name}
                href={site.url}
                target="_blank"
                rel="noreferrer"
                className="group overflow-hidden rounded-[20px] border border-slate-200 bg-white shadow-[0_8px_30px_rgba(15,23,42,.04)] transition duration-500 hover:-translate-y-1.5 hover:shadow-xl"
              >
                <div className="relative overflow-hidden bg-slate-100">
                  <img
                    src={site.image}
                    alt={site.name}
                    className="aspect-[16/10] w-full object-cover object-top transition duration-700 group-hover:scale-105"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#071a3b]/30 to-transparent opacity-0 transition group-hover:opacity-100" />
                </div>

                <div className="flex items-center justify-between px-4 py-4">
                  <div>
                    <p className="text-[9px] font-bold uppercase tracking-widest text-[#1573ff]">
                      Client Website
                    </p>

                    <p className="mt-1 text-xs font-black text-slate-700">
                      {site.name}
                    </p>
                  </div>

                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#f1f5f9] text-[#1573ff] transition group-hover:bg-[#1573ff] group-hover:text-white">
                    <ArrowUpRight size={14} />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          TESTIMONIAL
      ===================================================== */}

      <section className="relative overflow-hidden bg-[#071a3b] px-5 py-20 text-white sm:px-8 lg:px-12 lg:py-24">
        <div className="absolute -left-36 bottom-[-180px] h-[400px] w-[400px] rounded-full border border-blue-400/10" />

        <div className="absolute -right-24 top-[-120px] h-[400px] w-[400px] rounded-full bg-[#1573ff]/10 blur-[100px]" />

        <div className="relative mx-auto max-w-[1500px]">
          <div className="grid gap-10 lg:grid-cols-[.8fr_1.2fr] lg:items-center">
            {/* Heading */}

            <div>
              <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#4599ff] sm:text-xs">
                What Clients Say
              </p>

              <h2 className="mt-3 text-4xl font-black tracking-[-0.05em] sm:text-5xl">
                Real Words.
                <br />
                Real Trust.
              </h2>

              <p className="mt-4 max-w-md text-sm leading-6 text-white/45">
                Here's what our clients have to say about working with TECKANTS.
              </p>
            </div>

            {/* Testimonial Card */}

            <div className="relative overflow-hidden rounded-[26px] border border-white/10 bg-white/[0.045] p-6 backdrop-blur-xl sm:p-8">
              <div className="absolute right-6 top-[-5px] text-[100px] font-black leading-none text-[#1573ff]/15">
                “
              </div>

              <div className="relative">
                <div className="flex gap-1 text-[#ffd84d]">★ ★ ★ ★ ★</div>

                <p className="mt-5 max-w-2xl text-base leading-7 text-white/75 sm:text-lg sm:leading-8">
                  “TECKANTS delivered exactly what we needed — a clean, modern
                  website and solid digital marketing support. Our business has
                  seen real growth.”
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          CTA
      ===================================================== */}

      <section
        id="contact"
        className="bg-[#f5f9fe] px-5 py-12 sm:px-8 lg:px-12 lg:py-16"
      >
        <div className="mx-auto max-w-[1500px]">
          <div className="relative overflow-hidden rounded-[30px] border border-blue-100 bg-gradient-to-r from-[#edf5ff] via-white to-[#f0f5ff] px-6 py-12 sm:px-10 lg:px-16 lg:py-16">
            <div className="absolute right-[-100px] top-[-120px] h-[340px] w-[340px] rounded-full bg-[#1573ff]/10 blur-[70px]" />

            <div className="absolute bottom-[-130px] left-[35%] h-[300px] w-[300px] rounded-full bg-cyan-400/10 blur-[80px]" />

            <div className="relative grid gap-8 lg:grid-cols-[1fr_auto] lg:items-center">
              <div>
                <p className="text-[10px] font-black uppercase tracking-[0.25em] text-[#1573ff]">
                  Let's Work Together
                </p>

                <h2 className="mt-3 text-4xl font-black leading-[.9] tracking-[-0.06em] sm:text-5xl lg:text-6xl">
                  Ready to Build Your
                  <br />
                  <span className="text-[#1573ff]">Next Big Idea?</span>
                </h2>
              </div>

              <div>
                <p className="max-w-sm text-sm leading-6 text-slate-500">
                  Let's create something amazing together. Get in touch with us
                  for a free consultation.
                </p>

                <a
                  href="tel:+919442328166"
                  className="group mt-5 inline-flex items-center gap-3 rounded-full bg-[#1573ff] px-5 py-3.5 text-sm font-black text-white shadow-lg shadow-blue-500/20 transition hover:-translate-y-0.5 hover:bg-blue-700"
                >
                  Contact Us
                  <span className="transition group-hover:translate-x-1">
                    <ArrowRight size={16} />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-[#061735] px-5 py-10 text-white sm:px-8 lg:px-12">
        <div className="flex flex-col gap-3 border-t border-white/10 pt-6 text-[10px] text-white/30 sm:flex-row sm:items-center sm:justify-between">
          <span>
            © {new Date().getFullYear()} TECKANTS. All rights reserved.
          </span>

          <span>Websites · Digital Marketing · Social Media · Growth</span>
        </div>
      </footer>
    </main>
  );
}
